/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 * @author Maxim Fedorov
 * @author Yakov.Gushchin
 * @version 1.0.5
 * @since 1.0.0
 */
import { Component, createRef } from 'react';

import { EFormatData } from '../../../pages/PageDashboard/types/widgetTypes';
import { IRangeDatePickerCalendarBody } from './CalendarBody';
import { DayCellTdStyled, WeekCellTdStyled } from './styled/CalendarCellStyled';
import { cx, unitType } from './utils';

/**
 * @description Props for calendar day cell.
 * @interface IRangeDatePickerDayCell
 * @extend IRangeDatePickerCalendarBody
 *
 * @property {day} Day info for current cell.
 * @property{side} Left or Right side of calendar
 */
export interface IRangeDatePickerDayCell extends IRangeDatePickerCalendarBody {
    day: any;
    side: any;
}

/**
 * IRangeDatePickerWeekCell interface extend IRangeDatePickerCalendarBody.
 *
 * week: Week info for current row.
 */
interface IRangeDatePickerWeekCell extends IRangeDatePickerCalendarBody {
    week: any;
}

/**
 * DayCell component.
 *
 * Props: IRangeDatePickerDayCell.
 * Render day cell.
 */
export class DayCell extends Component<IRangeDatePickerDayCell> {

    private dayCellRef = createRef<HTMLTableDataCellElement>();

    /**
     * HandleOnMouseEnter - handle on mouse enter on day cell.
     */
    public handleOnMouseEnter = (): void => {
        const { onDayMouseEnter, day } = this.props;
        if (onDayMouseEnter) {
            onDayMouseEnter(day);
        }
    };

    /**
     * HandleOnClick - handle on click on day cell.
     */
    public handleOnClick = (): void => {
        const { onDayClick, day, side } = this.props;
        // @ts-ignore
        if (onDayClick && this.dayCellRef.current && !this.dayCellRef.current.classList.contains('disabled')) {
            onDayClick(day, side === 'left');
        }
    };

    public render() {
        const { day } = this.props;
        const className = cx({ ...this.props });
        const cellName = `${this.props.side}-${day.format('DD-MM-YYYY')}`;
        return <DayCellTdStyled
            className={className}
            id={cellName}
            ref={this.dayCellRef}
            onClick={this.handleOnClick}
            onMouseEnter={this.handleOnMouseEnter}
        >
            <div className="range-date-picker__day-cell">
                {day.format(EFormatData.OnlyDay)}
            </div>
        </DayCellTdStyled>;
    }
}

/**
 * WeekCell component.
 *
 * Props: IRangeDatePickerWeekCell.
 * Render week row.
 */
export class WeekCell extends Component<IRangeDatePickerWeekCell> {
    public render() {
        const { week } = this.props;
        return <WeekCellTdStyled>{week}</WeekCellTdStyled>;
    }
}

/* Return Day or Week cell */
export const cellMapper = {
    [unitType.DAY]: DayCell,
    [unitType.WEEK]: WeekCell,
};
